<template>
  <div class="h-full">
    <div class="md-layout chat-header rounded-tl-2xl">
      <div
        class="grow flex items-center text-[34px] pl-4 font-medium flex justify-center w-full"
      >
        <span class="mr-auto">
          {{ $t("chat_room.chats") }}
        </span>
        <!--   <span class="mr-auto">
           {{ isModeSupporter ? "Support chat" : $t("chat_room.chats") }}
         </span>
               <span v-if="!isModeSupporter" class="text-[16px] flex gap-3 pt-2 pr-4">
                   <img
                     @click="connectSupporter"
                     class="cursor-pointer"
                     src="/img/supporter.svg"
                   />-->
        <span class="pr-4" @click="addGroupModal" v-if="canAddGroupChat">
          <md-tooltip md-direction="top">Add group</md-tooltip>
          <md-icon class="text-[#fff] cursor-pointer">add_comment</md-icon>
        </span>
        <!--                </span>
                <span
                  v-if="isShowIconSupporter"
                  @click="switchAccountModal"
                  class="mr-4 cursor-pointer"
                >
                  <md-icon class="text-[#fff]">cached</md-icon>
                </span>-->
      </div>

      <div class="tab-bar w-full">
        <div class="tabs border-gray-300">
          <button
            class="text-[#fff] px-1"
            v-for="(tab, idx) in listTabs"
            :key="tab.name"
            :class="['tab-button w-1/2', currentTabIdx === idx && `active`]"
            @click="currentTabIdx = idx"
          >
            <span class="relative ">{{ $t(tab.label) }} </span>
          </button>
        </div>
      </div>
    </div>
    <div class="tabs border-t border-gray-300 body-tab-view">
      <keep-alive>
        <!--        <SupporterChat
                  v-if="isModeSupporter"
                  :socket-event="socketEvent"
                  ref="supporterChatRefs"
                  class="tab h-full"
                ></SupporterChat>-->
        <component
          :is="listTabs[currentTabIdx].component"
          :socket-event="socketEvent"
          ref="currentTabRefs"
          :tabChange="tabChange"
          class="tab h-full"
          @editGroup="editGroup"
        ></component>
      </keep-alive>
    </div>
    <!--    <common-modal
          height="auto"
          :name="modalNameSwitch"
          title="Wait a minute"
          hideFooter="true"
          hideHeader="true"
        >
          <template #modal-body>
            <div class="flex justify-between pb-5">
              <span class="font-medium text-[25px]">{{
                $t("chat_room.confirmation")
              }}</span>
              <span
                ><button
                  class="text-[30px] text-red-600"
                  @click.prevent="$modal.hide(modalNameSwitch)"
                >
                  <i class="fas fa-times"></i></button
              ></span>
            </div>
            <count-down-timer
              v-if="isWaiting"
              @time-up="isWaiting = false"
              :countdownTime="countdownTime"
              :time-left-props="timeLeft"
              class="mx-auto"
            ></count-down-timer>
            <p
              :class="{ 'text-red-600 text-center pt-5': isWaiting }"
              class="font-light text-[16px] "
            >
              {{ getContentMessage() }}
            </p>
            <div class="flex justify-end gap-3 pt-4">
              <md-button @click="hiddenModal" class=""
                >{{ $t("common.cancel") }}
              </md-button>
              <md-button
                :disabled="isWaiting"
                @click="switchAccount"
                class="md-success"
                >{{ $t("chat_room.switch") }}
              </md-button>
            </div>
          </template>
        </common-modal>-->
    <common-modal
      width="80%"
      height="auto"
      :name="groupModal.name"
      :hideFooter="true"
      :title="groupModal.header"
    >
      <template #modal-body>
        <GroupChatModal
          :data="groupModal.data"
          :type="groupModal.type"
          @closeModal="closeModal"
          @reloadGroup="reloadGroup"
        ></GroupChatModal>
      </template>
    </common-modal>
  </div>
</template>
<script>
import DirectChat from "@/pages/ChatRoom/Sidebar/Tabs/DirectChat";
import GroupChat from "./Tabs/GroupChat";
import CountDownTimer from "./Components/CountDownTimer";
import { mapGetters, mapMutations } from "vuex";
import GroupChatModal from "./Components/GroupChatModal";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";
// import switchAccountMixin from "./switch-account-mixin";
import { connectSocket } from "@/helpers/chat";

export default {
  components: { CountDownTimer, GroupChatModal },
  // mixins: [switchAccountMixin],
  inject: ["loginRocketChat"],
  data() {
    return {
      // isModeSupporter: null,
      // isShowIconSupporter: null,
      // componentKey: null,
      tabChange: null,
      listTabs: [
        {
          name: "direct-chat",
          label: "chat_room.direct_chat",
          component: DirectChat
        },
        {
          name: "group-chat",
          label: "chat_room.group",
          component: GroupChat
        }
      ],
      currentTabIdx: 0,
      socketEvent: null,
      groupModal: {
        type: "add",
        data: "",
        name: "GroupChatModal",
        header: this.$t("chat_room.add_new_group")
      }
    };
  },
  computed: {
    ...mapGetters("user", {
      userInfo: "info",
      userRole: "role"
    }),
    ...mapGetters("chat", ["isModeSupporterLocal"]),
    canAddGroupChat() {
      return !hasValidRole(this.userRole, [
        Role.Student,
        Role.Family,
        Role.Counselor
      ]);
    }
  },
  watch: {
    currentTabIdx: function(newVal) {
      this.$refs.currentTabRefs.unSelectRoomChat();
      this.$emit("clearIframe");
    }
    // isModeSupporter: function(newVal) {
    //   if (newVal) this.componentKey++;
    // }
  },
  created() {
    // this.setModeActive();
    const { uId, token } = {
      uId: this.userInfo.chat_id,
      token: this.userInfo.chat_token
    };
    connectSocket(uId, token);
    this.loginRocketChat();
  },
  methods: {
    ...mapMutations("chat", [
      "switchModeSupporter",
      "setTimeSwitchedModeSupporter"
    ]),
    //check mode is user or supporter
    /*setModeActive() {
     const query = this.$route.query;
     if (query.group_id || query.direct_id) {
     this.switchModeSupporter(false);
     }
     if (query.supporter_id && this.userInfo?.is_supporter) {
     this.isModeSupporter = true;
     this.isShowIconSupporter = true;
     return;
     }
     if (this.userInfo?.is_supporter) {
     if (this.isModeSupporterLocal !== null) {
     this.isModeSupporter = this.isModeSupporterLocal;
     } else {
     this.isModeSupporter = this.userInfo?.is_supporter;
     }
     } else {
     this.isModeSupporter = false;
     }
     this.isShowIconSupporter = !!this.userInfo?.is_supporter;
     },*/
    reloadGroup(groupName) {
      this.$modal.hide(this.groupModal.name);
      this.currentTabIdx = 1;
      this.$refs.currentTabRefs.searchUser(
        this.$refs.currentTabRefs?.currenSearchKey
      );
      groupName &&
        this.$refs.currentTabRefs.refreshGroup(
          Object.assign({}, this.groupModal.data, { name: groupName })
        );
    },
    addGroupModal() {
      this.groupModal.type = "add";
      this.groupModal.header = this.$t("chat_room.add_new_group");
      this.groupModal.data = "";
      this.$modal.show(this.groupModal.name);
    },
    editGroup(user) {
      this.groupModal.type = "edit";
      this.groupModal.header = this.$t("chat_room.edit_group");
      this.groupModal.data = user;
      this.$modal.show(this.groupModal.name);
    },
    closeModal() {
      this.$modal.hide(this.groupModal.name);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../node_modules/vue-material/dist/theme/engine";

.grow {
  flex-grow: 1;
}

.chat-header {
  @apply h-full bg-[#57AD7A] text-[#fff] rounded-tl-lg h-[120px] flex flex-col items-start;
}

.tab-button {
  @apply py-2 px-4;
  @apply text-gray-500 font-medium;
  @apply cursor-pointer;
  @apply outline-none;
  font-weight: 200;
  font-size: 14px;

  &.active {
    border-bottom: 3px solid md-get-palette-color(#fff, 500);
    font-weight: 500;
    font-size: 16px;
    border-radius: 3px;
  }
}

.body-tab-view {
  height: calc(100% - 120px);
}
</style>
